import {
    cloneElement,
    type FC
} from "react";
import type {
    GestureResponderEvent
} from "react-native";
import type ISheetTriggerProps from "./type";
import {
    useSheetContext
} from "../../context";

const SheetTrigger: FC<ISheetTriggerProps> = ({
    children
}) => {
    const sheet = useSheetContext({
        part: "Trigger"
    });

    if(!sheet) {
        return null;
    }

    const onPress = (event: GestureResponderEvent) => {
        if(children.props.onPress) children.props.onPress(event);

        sheet.requestOpen();
    };

    return cloneElement(children, {
        "aria-controls": sheet.contentId,
        "aria-expanded": sheet.isOpen,
        "aria-haspopup": "dialog",
        onPress
    });
};
export default SheetTrigger;
